import { CartActionTypes } from "./cart.types";
import { addItemToCart, removeItemFromCart } from "./cart.utils";


const INITIAL_STATE = {
  // hide dropdown when come to the website
  hidden: true,
  cartItems: [],
};

const cartReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CartActionTypes.TOGGLE_CART_HIDDEN:
      return {
        ...state,
        hidden: !state.hidden,
      };
    case CartActionTypes.ADD_ITEM:
      return {
        // ...state = overall cart reducer
        ...state,
        // spreading in the existing cart items and append the new item we get as payload in the end of the array
        // the payload array
        cartItems: addItemToCart(state.cartItems, action.payload),
      };
    // decrease quantity = remove item if 0
    case CartActionTypes.REMOVE_ITEM:
      return {
        ...state,
        cartItems: removeItemFromCart(state.cartItems, action.payload)
      };

    // delete cart
    case CartActionTypes.CLEAR_ITEM_FROM_CART:
      return {
        ...state,
        // return new array without instance
        // filter always returns true (give back new array)
        cartItems: state.cartItems.filter((cartItem) => cartItem.id !== action.payload.id),
      };
    case CartActionTypes.CLEAR_CART:
      return {
        ...state,
        cartItems: []
      }
    // Firebase
    case CartActionTypes.SET_CART_FROM_FIREBASE:
      return {
        ...state,
        cartItems: action.payload,
      }
    default:
      return state;
  }
};

export default cartReducer;
